import React from "react";
import "./style.scss";
import BatchLoading from "../../../components/Seggregation/BatchLoading";
const BatchLoadingPage = () => {
  return (
    <div className="batch_loading_page_wrapper">
      <BatchLoading />
    </div>
  );
};
export default BatchLoadingPage;
